import { gql } from '@apollo/client';
import { TaxProfileReviewInfo } from '../fragments';

export default gql`
  query TaxProfileReviews($productId: ID, $state: String) {
    taxProfileReviews(productId: $productId, state: $state) {
      ...TaxProfileReviewInfo
    }
  }
  ${TaxProfileReviewInfo}
`;
